<template>
    <div class="table-responsive mb-0">
        <table class="table table-sm table-bordered mb-0">
            <tbody>
                <tr>
                    <th class="w-50">Personel</th>
                    <td class="w-50">{{ $safe(value,'FullName') }}</td>
                </tr>
                <template v-if="levies && !leviesLoading">
                    <tr>
                        <th>Ödenen Toplam İcra</th>
                        <td class="text-right">{{ $safe(levies,'PaidDebt') }}</td>
                    </tr>
                    <tr>
                        <th>Bekleyen Toplam İcra</th>
                        <td class="text-right">{{ $safe(levies,'RemainingDebt') }}</td>
                    </tr>
                    <tr>
                        <th>Toplam İcra</th>
                        <td class="text-right">{{ $safe(levies,'TotalDebt') }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="p-50">
                            <table class="table table-sm mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-nowrap">Sabit</th>
                                        <th class="text-nowrap">Dosya Numarası</th>
                                        <th class="text-nowrap text-right">Ödenen Tutar</th>
                                        <th class="text-nowrap text-right">Kalan Tutar</th>
                                        <th class="text-nowrap text-right">Toplam Tutar</th>
                                        <th class="text-nowrap"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="levy in $safe(levies,'Levies')">
                                        <td>
                                            <div class="d-flex justify-content-center">
                                                <span class="material-icons-outlined d-block text-success" v-if="$safe(levy,'FixedDeduction')">check_circle</span>
                                                <span class="material-icons-outlined d-block text-danger" v-else>cancel</span>
                                            </div>
                                        </td>
                                        <td class="text-nowrap">{{ $safe(levy,'FileNumber') }}</td>
                                        <td class="text-nowrap text-right">{{ $safe(levy,'CurrentPaidDebtString') }} ₺</td>
                                        <td class="text-nowrap text-right">{{ $safe(levy,'CurrentRemainingDebtString') }} ₺</td>
                                        <td class="text-nowrap text-right">{{ $safe(levy,'TotalDebtAmountString') }} ₺</td>
                                        <td>
                                            <v-currency-input  input-class="text-right form-control-sm" :value="levy.NAmount" v-on:update-value="currencyAmount => {levy.NAmount = currencyAmount; setLevies()}"></v-currency-input>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bolder text-primary">Hesaplanan Tutar</td>
                        <td class="text-right">{{ convertMoney(calculatedTotal) }} ₺</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bolder text-primary">Eklenen Tutar</td>
                        <td class="text-right">{{ convertMoney(addedTotal) }} ₺</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bolder text-secondary">Bu Ay ({{cm}}) İcra İçin Ödenecek Toplam Tutar</td>
                        <td class="font-weight-bolder text-right">{{ convertMoney(total) }} ₺</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="bg-light p-50">
                            <textarea v-model="value.Description" class="form-control resize-none" rows="3" placeholder="Açıklama"></textarea>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="2" class="text-center p-75">
                        <b-spinner small></b-spinner>
                        İcralar yükleniyor...
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import Additional from '@/utilities/additional'
import { BSpinner } from 'bootstrap-vue';

export default {
    components:{
        VCurrencyInput,
        BSpinner
    },
    props:{
        value:Object,
        salaryPaymentDate:String | null,
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    mounted(){
        this.getLevy()
    },
    data(){
        return {
            levies:null,
            leviesLoading:false
        }
    },  
    methods:{
        getLevy(){
            this.leviesLoading = true
            EmployeeOperationsApi.Levy.GetByEmployee({
                EmployeeId:this.value.EmployeeId,
                SalaryPaymentDate:this.salaryPaymentDate,
                Month:this.filter?.Month || null,
                Year:this.filter?.Year || null,
                SGKJobNoticeId:this.value.SGKJobNoticeId
            }).then(res => {
                if(res.data.Success){
                    this.levies = res.data.Data
                    debugger;
                    this.levies.Levies = this.levies.Levies?.map(l => ({
                        ...l,
                        NAmount:l.PaidOnThisNotice?.Amount || null
                    }))
                    this.value.Amount = this.total
                    this.value.Description = res.data.Data.InterventDescription
                }else{
                    this.$result(res)
                }
                this.leviesLoading = false
            }).catch(err =>  {
                this.$result(null,err)
                this.leviesLoading = false
            })
        },
        convertMoney(n){
            return Additional.ConvertMoney(n)
        },
        setLevies(){
            this.value.AdditionalLevyPayments = this.levies?.Levies?.map(l => ({
                Amount: l.NAmount || 0,
                EmployeeLevyPaymentId: l.PaidOnThisNotice?.EmployeeLevyPaymentId || null,
                EmployeeLevyId: l.Id,
                SGKJobNoticeId:this.value.SGKJobNoticeId
            }))
            this.value.Amount = this.total
        },
    },
    computed:{
        calculatedTotal(){
            return (this.value.CalculatedAmount || 0)
        },
        addedTotal(){
            return this.levies?.Levies?.reduce((s,l) => s+= (l.NAmount ||0),0) - this.calculatedTotal
            // if(this.notChanged){
            // } else 
            // return (this.levies?.Levies?.reduce((s,l) => s += ((l.NAmount - (l.PaidOnThisNotice?.Amount || 0) )|| 0),0) || 0)
        },
        // notChanged(){
        //     return this.levies?.Levies?.every(l => l.NAmount == l.PaidOnThisNotice?.Amount)
        // },
        total(){
            return this.calculatedTotal + this.addedTotal
        },
        cm(){
            return Additional.GetMonthName(this.filter.Month || 0)
        }
    }
}
</script>